import { useTranslation } from '@edreamsodigeo/frontend-core';

export const ProductTermsAndConditionsStandardLabel = () => {
  const { t } = useTranslation();
  return t('paymentpage.terms.productspecific.link.label');
};
